import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { justifiInlineStyles, justifiOverrideStyles } from '../global.styles';

export const inlineStyles = [
  justifiInlineStyles.styles,
  css(`

    ::part(tooltip){
      opacity: 1;
    }
    ::part(tooltip-inner) {
      background: ${theme.colors.neutral90};
      padding: ${theme.spacing(1)};
      font-size: ${theme.font.size.medium};
      color: ${theme.colors.neutral5};
      opacity: 1;
    }
  `).styles,
].join('\n');

export const overrideStyles = css`
  ${justifiOverrideStyles.styles}
  form-control-tooltip,
  .tooltip-container {
    height: 16px;
  }

  .tooltip-container svg,
  .tooltip-container svg path {
    fill: ${theme.colors.neutral50};
    color: ${theme.colors.neutral50};
  }

  form-control-tooltip {
    background: ${theme.colors.white};
    border-radius: 50px;
  }

  form-control-monetary label {
    margin-bottom: 4px !important;
    margin-left: 4px !important;
  }

  .d-flex.align-items-center:has(legend) {
    display: inline-flex !important;
  }
`.styles;

export const styles = {
  formWrapper: css`
    position: relative;
  `,
  pendingOverlay: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(115, 115, 115, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  `,
};
